import { useState } from 'react';

import { useSendFeedbackMutation } from '../../graphql';

export const Help: React.FC = () => {
	const [feedbackText, setFeedbackText] = useState<string>('');

	const [submitFeedback] = useSendFeedbackMutation({
		variables: {
			feedback: { category: 'Online Ordering Help', feedbackText }
		}
	});

	return (
		<div className="text-left">
			<h1 className="text-primary my-3 text-center">Help</h1>

			<form className="mt-4" onSubmit={() => submitFeedback()}>
				<div className="d-flex flex-column">
					<div className="form-group">
						<h2 className="text-secondary text-center">
							<label
								htmlFor="textArea"
								style={{ width: 'unset' }}
							>
								Please tell us about the issue you are having!
							</label>
						</h2>

						<textarea
							onChange={e => setFeedbackText(e.target.value)}
							className="form-control"
							id="exampleFormControlTextarea1"
							rows={10}
						></textarea>
					</div>

					<button
						type="submit"
						className="btn btn-success text-white btn-lg float-right col-lg-2 align-self-center col-xs-6"
					>
						Submit
					</button>
				</div>
			</form>
		</div>
	);
};
